export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6245.e2d46b11.jpg";